module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZTRDQIhDIaLcQBHwA0cwRXcwFFuE3UEJzg3cARuA2+DWgwkBGmlwpPelzRHoOUvlB7A34CIG7IT2QPfuft1aCUISLQJhVNEbDJvuwklmzlm3l+hUwsxNeBEXBjrhLBcA1dIJJ7EqoQwqwEy1xV8R+QZU99VFhszmIwxE8gcyC7MmpVEqqEkZrKjSaDpbcn3axENi0hXkTl8/dO28JldFvdiLUX4F0Sb32i4J3M0hkqu7Eqp+UKDnrEO/wcYQELq8Bb/vCZdalCT3Yh6Bo1G/xr8FE+IewexAYraNAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-copy.png
// module id = 1061
// module chunks = 0